module.exports = __webpack_public_path__ + "static/media/20170806_46day_2229AT.7ec3e928.jpg";